import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';

export const adminGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  if (adminAuth.isAdminAuthenticated() && adminAuth.isAdmin()) {
    return true;
  }

  router.navigate(['/admin/login']);
  return false;
};
